import { useAppStore } from '../app/store/useAppStore';
import { BottomNav } from '../components/navigation/BottomNav';

const abilities = ['互動體驗設計', 'AI / Generative Design', 'AR / Spatial Experience'];
const works = [
  { index: '01', title: 'SPATIAL ENCOUNTER', type: 'Interactive Installation' },
  { index: '02', title: 'GENERATIVE IDENTITY', type: 'AI Design System' },
  { index: '03', title: 'MOTION OBJECTS', type: 'Digital Experience' },
];
const portfolioUrl = 'https://luns-portfolio.pages.dev/';
const instagramUrl = 'https://www.instagram.com/LUN10238/';
const email = 'newtwps123@gmail.com';

export function ProfilePage() {
  const navigate = useAppStore((state) => state.navigate);
  return <main className="screen profile-screen with-bottom-nav">
    <header className="page-header"><div><span className="micro-label">DIGITAL FASHION PROFILE</span><h1>個人介紹</h1></div><b className="focus-mark">[•]</b></header>
    <section className="profile-identity"><div className="profile-avatar large">L</div><div><h2>LUN</h2><p>Interactive Designer<br/>Creative Technologist</p></div><span className="profile-index mono">NO. 001</span></section>
    <p className="profile-intro">在實體空間、影像與程式之間，設計讓人願意靠近並留下記憶的互動體驗。</p>
    <section className="profile-section"><div className="section-heading"><span>代表能力</span><small>CAPABILITIES / 03</small></div><ol className="ability-list">{abilities.map((ability, index) => <li key={ability}><span>0{index + 1}</span>{ability}</li>)}</ol></section>
    <section className="profile-section"><div className="section-heading"><span>精選作品</span><small>SELECTED WORK / 03</small></div><div className="work-list">{works.map((work) => <article key={work.index}><span>{work.index}</span><div><h3>{work.title}</h3><p>{work.type}</p></div><i/></article>)}</div></section>
    <section className="contact-section" aria-labelledby="contact-heading">
      <a
        className="portfolio-qr"
        href={portfolioUrl}
        target="_blank"
        rel="noopener noreferrer"
        title={portfolioUrl}
        aria-label="開啟 LUN 作品集：luns-portfolio.pages.dev（另開新視窗）"
      >
        <img src="/icons/lun-portfolio-qr.svg" width="112" height="112" alt="掃描前往 LUN 作品集" />
        <span className="mono">SCAN / PORTFOLIO</span>
      </a>
      <div className="contact-links">
        <span id="contact-heading" className="micro-label">PORTFOLIO / CONTACT</span>
        <a href={portfolioUrl} target="_blank" rel="noopener noreferrer" title={portfolioUrl} aria-label={`Website：${portfolioUrl}（另開新視窗）`}>
          <span>Website</span><strong>luns-portfolio.pages.dev</strong><b aria-hidden="true">↗</b>
        </a>
        <a href={instagramUrl} target="_blank" rel="noopener noreferrer" title={instagramUrl} aria-label={`Instagram：@LUN10238（另開新視窗）`}>
          <span>Instagram</span><strong>@LUN10238</strong><b aria-hidden="true">↗</b>
        </a>
        <a href={`mailto:${email}`} title={email} aria-label={`Email：${email}`}>
          <span>Email</span><strong>{email}</strong><b aria-hidden="true">↗</b>
        </a>
      </div>
    </section>
    <button className="outline-button profile-capture" onClick={() => navigate('CAMERA_INIT')}>一起拍一張</button>
    <BottomNav active="profile"/>
  </main>;
}
